module.exports = __webpack_public_path__ + "static/media/BigPictureIcon.79b9eaf2.svg";